import { getAmplitudePageType } from './amplitude';

import type { AmplitudeEventBase, AmplitudeEventTypes } from 'types/amplitude';

interface BuildAmplitudeEventParams<T> {
  event: AmplitudeEventTypes;
  pageType?: string;
  sessionId: string;
  componentName: string;
  componentType: string;
  componentContext: string;
  isRecognizedCustomer: boolean;
  isEnrolledInVip: boolean;
  directedID?: string;
  trackingPayload?: T;
}

export const buildAmplitudeEvent = <T extends Record<string, unknown>>({
  event,
  pageType,
  sessionId,
  componentName,
  componentType,
  componentContext,
  isRecognizedCustomer,
  isEnrolledInVip,
  directedID,
  trackingPayload
}: BuildAmplitudeEventParams<T>): AmplitudeEventBase & T => {
  const amplitudePageType = getAmplitudePageType(pageType);

  return {
    event,
    pageLang: 'en',
    pageType: amplitudePageType,
    component: {
      name: componentName,
      type: componentType,
      context: componentContext
    },
    sessionId,
    screen: {
      name: amplitudePageType,
      type: amplitudePageType
    },
    user: {
      login_status: isRecognizedCustomer ? 'AUTHED' : 'UNAUTHED',
      vip_status: isEnrolledInVip ? 'enrolled' : 'not_enrolled',
      directedID
    },
    ...(trackingPayload ?? {})
  } as AmplitudeEventBase & T;
};
